import imgRequests from 'images/ic_requests.svg';
import imgRequestsActive from 'images/ic_requests_active.svg';

const referrerFeatures = [
	{
		tabId: 'referrerDashboard',
		tabName: 'My Patients',
		mobileTabName: 'Patients',
		tabIconActive: (
			<img className="tab-img" src={imgRequestsActive} alt="PatientsActive" />
		),
		tabIconInactive: (
			<img className="tab-img" src={imgRequests} alt="PatientsInactive" />
		),
		to: '/referrer/dashboard',
		childs: [],
	},
];

export default referrerFeatures;
